import { Instance, types } from 'mobx-state-tree';

export type ToolbarDesktopInstance = Instance<typeof ToolbarDesktop>;

export const ToolbarDesktop = types
  .model({
    isToolbarOpen: types.boolean,
    triggerOpen: types.optional(types.boolean, false),
  })
  .volatile(self => ({
    handleToggleClose: ({ onlyClose, id }: { onlyClose: boolean; id?: string }) => {},
    onPressChangeFormat: () => {},
    setActiveLookup: (value: string) => {},
  }))
  .actions(self => {
    return {
      setIsToolbarOpen: (value: boolean) => {
        self.isToolbarOpen = value;
      },
      setTriggerOpen: (value: boolean) => {
        self.triggerOpen = value;
      },
      setHandleToggleClose: (handleToggleClose: ({ onlyClose, id }: { onlyClose: boolean; id?: string }) => void) => {
        self.handleToggleClose = handleToggleClose;
      },
      setOnPressChangeFormat: (onPressChangeFormat: () => void) => {
        self.onPressChangeFormat = onPressChangeFormat;
      },
      setSetActiveLookup: (setActiveLookup: (value: string) => void) => {
        self.setActiveLookup = setActiveLookup;
      },
    };
  });
